/**
 * Angular imports.
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Service imports.
 */
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';

/**
 * import constants
 */
import { PRODUCT_TYPE_CONSTANT } from '../../../../app/constants/app.constants';
import { SEARCH_FILTER } from '../../../constants/data-testId.constants';

/**
 * import interface
 */
import { EventTrackerConfig } from '../../../../app/interface/event/event';
@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss']
})
export class SearchFilterComponent {

  @Input() filterData;
  @Input() selected_filter;
  @Output() setFilter = new EventEmitter<number>();

  @Output() setValue = new EventEmitter<string>();
  /**
   * default configuration for event tracker
   */
  eventTrackerConfig: EventTrackerConfig = {
    'category': this.mls.googleEventText.global_search.category,
    'action': this.mls.googleEventText.global_search.key4,
    'product_type': PRODUCT_TYPE_CONSTANT.SEARCH,
    'product_id': ''
  };

  /**
   * Data test id for the search filter .
   */
  public dataTestId = SEARCH_FILTER;

  /**
   * Necessary instances.
   */
  constructor(public mls: NewLanguageService) { }

  /**
   * Angular imports.
   */
  applyFilter(filter): void {
    this.selected_filter = filter.value;
    this.setFilter.emit(parseInt(this.selected_filter, 10));
    this.setValue.emit(filter.name);
  }
}
